export default "/_next/static/images/f163238f3726d7f640f52ba3f6e856c5.svg";